var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:['content-header', _vm.sticky && 'content-header-sticky']},[(_vm.prev)?_c('router-link',{staticClass:"icon-button",attrs:{"tag":"button","to":_vm.prev,"type":"button"}},[_c('icon',{attrs:{"name":"prev"}})],1):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }